import Icon from '../components/Icon.vue'

Icon.register({"robot":{"width":640,"height":512,"paths":[{"d":"M0 256V384C0 401.7 14.3 416 32 416H64V224H32C14.3 224 0 238.3 0 256zM464 96H352V32C352 14.3 337.7 0 320 0S288 14.3 288 32V96H176C131.8 96 96 131.8 96 176V448C96 483.3 124.7 512 160 512H480C515.3 512 544 483.3 544 448V176C544 131.8 508.2 96 464 96zM256 416H192V384H256V416zM224 296C201.9 296 184 278.1 184 256S201.9 216 224 216 264 233.9 264 256 246.1 296 224 296zM352 416H288V384H352V416zM448 416H384V384H448V416zM416 296C393.9 296 376 278.1 376 256S393.9 216 416 216 456 233.9 456 256 438.1 296 416 296zM608 224H576V416H608C625.7 416 640 401.7 640 384V256C640 238.3 625.7 224 608 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/robot.js
// module id = zwhv
// module chunks = 0